import React from 'react';
import { Person } from './types';
import Avatar from './Avatar';

export default function PersonListItem({
  firstName,
  companyName,
  profileImage,
  linkedIn,
  lastName,
  title,
  email,
  onSelect,
  questions,
  questionAnswers,
  lang,
}: Person & { onSelect: () => void; questionAnswers: string[]; lang: string }) {
  let details = [companyName, title].filter(Boolean).join(' • ');

  if (questionAnswers.length > 0) {
    details += ` • ${[
      ...new Set(
        questions
          .filter(question => questionAnswers.includes(question.questionId))
          .map(question => question.questionOptionLabel?.find((option: any) => option.languageCode === lang)?.label)
      ),
    ].join(' • ')}`;
  }

  return (
    <div className="flex x w-full py-3 px-3  hover:bg-neutral-200 cursor-pointer" onMouseDown={onSelect}>
      <div className="mr-4 flex-center">
        <Avatar person={{ firstName, lastName, profileImage }} />
      </div>
      <div className="flex gap-y-1 items-start flex-col">
        <span className="font-bold">
          {firstName} {lastName}
        </span>
        <div className="flex w-full justify-between">
          <div>{details}</div>
        </div>
      </div>
    </div>
  );
}
